// extracted by mini-css-extract-plugin
export default {"title":"ActionsTitle_title__sDNO9"};